import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CollageBorderComponent } from './collage-border.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { DxColorBoxModule } from 'devextreme-angular';
import { DragDropModule } from '@angular/cdk/drag-drop';


@NgModule({
    declarations: [
        CollageBorderComponent
    ],
    imports: [
        CommonModule, DragDropModule,
        MatButtonModule, MatIconModule, MatSnackBarModule,
        MatSliderModule, MatDialogModule,
        DxColorBoxModule,
    ]
})
export class CollageBorderModule { }
